import { ISelectOption } from "./selectOption.interface";
import { FilterTypesEnum } from "../filters/filterTypes.enum";
import { ResourceStatus } from "../api/inventoryResource.model";
import { beautifyCamelCaseString } from "src/app/common/stringUtils";

export const ResourceStatusSelectOptions: ISelectOption[] = [
    {
        id: `${FilterTypesEnum.ResourceStatus}-${ResourceStatus.active}`,
        value: ResourceStatus.active,
        displayName: beautifyCamelCaseString(ResourceStatus.active),
        categoryName: FilterTypesEnum.ResourceStatus.toString(),
        filterType: FilterTypesEnum.ResourceStatus,
    },
    {
        id: `${FilterTypesEnum.ResourceStatus}-${ResourceStatus.inactive}`,
        value: ResourceStatus.inactive,
        displayName: beautifyCamelCaseString(ResourceStatus.inactive),
        categoryName: FilterTypesEnum.ResourceStatus.toString(),
        filterType: FilterTypesEnum.ResourceStatus,
    },
    {
        id: `${FilterTypesEnum.ResourceStatus}-${ResourceStatus.pendingDeletion}`,
        value: ResourceStatus.pendingDeletion,
        displayName: beautifyCamelCaseString(ResourceStatus.pendingDeletion),
        categoryName: FilterTypesEnum.ResourceStatus.toString(),
        filterType: FilterTypesEnum.ResourceStatus,
    },
];
